
export const SHIMONO = { name: 'Shimono Ken',
    role: 'Head Coach | Director',
    details: '',
    edu: '',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Shimono.png'
}

export const SUZUKI = { name: 'Suzuki Hideo',
    role: 'Bullpen Coach',
    details: '',
    edu: '',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Suzuki.png'
}

export const NAMASHITA = { name: 'Namashita Tatsuji',
    role: 'Batters Coach',
    details: '',
    edu: '',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Namashita.png'
}

export const YAMAMOTO = { name: 'Yamamoto Susumu',
    role: 'Bullpen Coach',
    details: '',
    edu: '',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Yamamoto.png'
}

export const AKAGI = { name: 'Akagi Satoshi',
    role: 'Physical Therapist',
    details: '',
    edu: '',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Akagi.png'
}

export const TANAKA = { name: 'Tanaka Ryo',
        role: 'Manager Director',
        details: '',
        edu: '',
        affiliation: 'Tokyo Six University Baseball Federation',
        photo:'/Tanaka.png'
    }
